import useTrackingEvents from '~/composables/tracking/useTrackingEvents'

export default () => {
  const { fireTrackingServerQueue, trackSelectItem, trackViewItemList } =
    useTrackingEvents(true)

  return {
    fireTrackingServerQueue,
    trackSelectItem,
    trackViewItemList,
  }
}
